import React from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../../shared/Layout/Layout";
import leftArrow from "../../assets/leftArrow.svg";
import Card from "../../components/_settings/Card/Card";
import { PATHS } from "../../routes/paths";
import styles from "./Settings.module.scss";

const Settings = () => {
  const navigate = useNavigate();
  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.subContainer}>
          <div className={styles.leftArrow} onClick={() => navigate(PATHS.home)}>
            <img src={leftArrow} alt="go-back" />
          </div>
          <h1>Settings</h1>

          <Card navigate={navigate} PATHS={PATHS} />
        </div>
      </div>
    </Layout>
  );
};

export default Settings;
